export const NOTIFICATIONS_COLUMNS = {
	processed: "text_mm4r28yt",
	pulseId: "text_mm4rwtxv",
	time: "date_mm4rs1x6",
	boardId: "text_mm4rwct2",
	userIds: "text_mm4r17nv",
};
